/* eslint-disable react/no-unescaped-entities */
import {styled} from '@mui/material/styles'
import Typography from '@mui/material/Typography'
const PREFIX = 'PrivacyStatement'

const classes = {
  underlineHeadings: `${PREFIX}-underlineHeadings`
}

// eslint-disable-next-line no-unused-vars
const Root = styled('div')(({theme}) => ({
  [`& .${classes.underlineHeadings}`]: {
    textDecoration: 'underline'
  }
}))

const PrivacyStatement = () => {
  return (
    <Root tabIndex={0} aria-label='privacy-statement'>
      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        This Privacy Notice explains how Deloitte Consulting LLP (“we” or “us”) protects the personal information
        collected from your use of the application that links to this privacy statement (the “Application”). By using
        the Application, you agree to the use of your personal information in accordance with this Privacy Notice.
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Information collection
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        We may collect personal information when you interact with the Application, such as if you register or create a
        user profile on the Application and when you log-in to the Application. Such information may consist of your
        name, email address, username and password for the Application, and other personal information you provide to us
        in the Application.
        <br />
        In addition, if you are accessing the Application from a mobile device, we or our service providers (such as
        mobile operating system and platform providers) may also collect information relating to your device, including
        your device model, operating system, browser type, unique device identifier, IP address, mobile phone number,
        mobile network carrier, location, and the way you are using the Application. The information collected will
        depend on the functionality of the Application. If any other information is collected relating to your use of
        the Application, such information will be specified in the Application.
        <br />
        We do not usually seek to collect sensitive personal information (i.e., data relating to race or ethnic origin,
        religious or philosophical beliefs, trade union membership, political opinions, medical or health conditions, or
        information specifying the sex life or sexual orientation of an individual) from users. We will, where
        necessary, obtain your explicit consent to collect and use such information.
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Log information, cookies and Web beacons
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        The Application may use standard information-gathering tools, such as log files, cookies (small text files
        stored in a user's browser), and web beacons (electronic images that allow us to count users who have accessed
        particular content and to access certain cookies) to collect aggregate data while you use the Application. More
        information regarding these practices can be found in our{' '}
        <a href='https://www2.deloitte.com/us/en/legal/cookies.html' aria-label='information-about-cookies'>
          Cookies Notice.
        </a>
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Privacy Shield Notice
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        We adhere to the EU-U.S. and Swiss-U.S. Privacy Shield Framework as set forth by the U.S. Department of Commerce
        with respect to personal information that is transferred from the European Economic Area, the United Kingdom and
        Switzerland to the United States within the scope of our Privacy Shield certification. To learn more, see our{' '}
        <a href='https://www2.deloitte.com/us/en/legal/privacy-shield.html' aria-label='privacy-shield'>
          Privacy Shield Notice.
        </a>
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Information use
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        We collect and use your personal information with your consent to provide you with access to the Application, or
        where we have a legitimate business interest in or other legal basis for, such collection and use. The personal
        information you submit to us may be used to manage our relationship with you, including any of your requests, or
        to customize or improve the Application. Your personal information may also be used to protect our rights or
        property and that of our users.
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Disclosure of information to third parties
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        Your personal information may be disclosed to third party service providers and members of the “Deloitte
        Network” (defined as Deloitte Touche Tohmatsu Limited, its member firms, and their affiliates and related
        entities) who may use the information in order to respond to your requests or inquiries or provide services on
        our behalf; or as part of a corporate transaction (such as a sale, divestiture, reorganization, merger or
        acquisition).
        <br />
        Personal information may also be disclosed to law enforcement, regulatory or other government agencies, or with
        other third parties, in each case to comply with legal, regulatory, or national security obligations or
        requests.
        <br />
        When the Application is accessed using a mobile device, we may also share your usage and personal information
        with mobile carriers and platform providers, as well as any other entities described in the Application in
        connection with the operation of the Application.
        <br />
        All of these disclosures may involve the transfer of personal information to countries or regions without data
        protection rules similar to those in effect in your area of residence.
        <br />
        By providing information with respect to the Application, you are consenting to the disclosures described above.
        <br />
        Any personal information that we have referenced above under “Information collection” may be disclosed to the
        third parties identified in this section for the purposes set forth herein.
        <br />
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Selling information
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        We do not sell your personal information that is collected under this Privacy Notice
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Do Not Track
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        “Do Not Track” or “DNT” is a preference you can set in your Web browser to let the websites you visit know that
        you do not want them collecting information about you. The application does not currently respond to a "Do Not
        Track" or similar signal. We do not engage in the collection of PI about your online activities over time and
        across third-party websites or online services to provide targeted advertising. We do not allow third parties to
        collect such PI when you use the application.
        <br />
        In response to California law, if you are a California resident, you are entitled to request information
        concerning whether your PI has been disclosed to nonaffiliated third parties for their direct marketing
        purposes. We do not share your PI with nonaffiliated third parties for such purposes.
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Information security
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        We have in place reasonable commercial standards of technology and operational security to protect all personal
        information provided by you with respect to the Application, from unauthorized access, disclosure, alteration or
        destruction.
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Changes to our Privacy Notice
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        In addition to describing our current privacy practices, this Privacy Notice also describes the categories of
        personal information we collected, disclosed or sold during the preceding 12 months. We may modify or amend this
        Privacy Notice from time to time at our discretion. When we make changes to this Privacy Notice, we will amend
        the revision date at the bottom of this page and such modified or amended Privacy Notice shall be effective as
        to you and your information as of that revision date. We encourage you to periodically review this Privacy
        Notice to view any updates.
      </Typography>

      <Typography tabIndex={0} className={classes.underlineHeadings} variant='subtitle1' component='div' gutterBottom>
        Contact Information
      </Typography>

      <Typography tabIndex={0} variant='subtitle2' component='div' gutterBottom>
        If you have any questions or concerns regarding your privacy while using the Application, please contact us at{' '}
        <a href='mailto:ushealthprismsupport@deloitte.com' aria-label='mail-to'>
          ushealthprismsupport@deloitte.com
        </a>{' '}
        or call us at 844.919.0711.
      </Typography>

      <Typography tabIndex={0} variant='caption' component='div' gutterBottom>
        Last Updated on: July 31, 2020
      </Typography>
    </Root>
  )
}

export default PrivacyStatement
